import { AppConfig, AppSlugs, CapabilityApplications } from '@hcs/types';

export const APP_CONFIG_ACCESS_CANARY_COMMAND: AppConfig = {
  name: 'Canary Command',
  appSlug: AppSlugs.AccessPartnerTools,
  applicationKey: CapabilityApplications.InternalAgileOps,
  rootPath: '/',
  descriptionLong: '',
  descriptionShort: '',
  feOnlyApp: true,
};

export enum VIEW_PATHS_ACCESS_PARTNER_TOOLS {
  LOGIN = '/login',
  LOGOUT = '/logout',
  LANDING = '/landing',
  FORGOT_PASSWORD = '/forgot-password',
  RESET_PASSWORD = '/reset-password',
}
